import { render, staticRenderFns } from "./fuwu.vue?vue&type=template&id=a348b354&"
import script from "./fuwu.vue?vue&type=script&lang=js&"
export * from "./fuwu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports